module.exports = "/static/assets/999b009161f90685de12f1c0caa5c44a.png";